export default {
  container: {
    margin: '5px 20px 20px 20px',
    height: '100%',
  },
} as const;
